<template>
<div class="chapter">
<div class="inner_page">
<p class="tp-title"><a id="page_i"></a>The Great Game</p>
<p class="tp-subtitle">The Complete Series</p>
<p class="author">Dave Duncan</p>
<div class="author">
<img alt="image" src="Common/logo.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?69b7694f